module.exports = __webpack_public_path__ + "static/media/david.3ad4768c.jpg";